import React from 'react';
import PropTypes from 'prop-types';
import FormdataWizard from 'react-formdata-wizard';
import DecideUpgradeStep from './DecideUpgradeStep';
import { getMessageId } from '../../../contexts/NotificationsContext/notificationsContextHelper';

function UpgradeWizard(props) {
  const { message } = props;
  const parentElementId =  getMessageId(message);
  return (
    <FormdataWizard name='upgrade_wizard' defaultFormData={{parentElementId}}>
      <DecideUpgradeStep />
    </FormdataWizard>
  );
}

UpgradeWizard.propTypes = {
  onFinish: PropTypes.func,
  showCancel: PropTypes.bool
};

export default UpgradeWizard;

